import { formatSearchParams } from "@/components/SearchWidget/SearchWidget.utils";
import { searchActionConstants } from "@/store/actions";
import {Period} from "@/shared/utils/search/search.constants";
import { _sharedReducerSearch, _sharedStateSearch } from "@/shared/store/search/reducer";
import { SEARCH_PARAM_QUERY_NAME } from "@/utils/search";

export const initialState = {
  isShownMarks: true,
  currentItemIndex: -1,
  search: {
    total: 0,
    results: [],
    languageFacets: {},
  },
  searchParams: {
    [SEARCH_PARAM_QUERY_NAME]: "",
    folders: [],
    context: "",
    extras: {
      type: "basic",
      snippet: "long",
      period: Period.both,
    },
  },
  searchDictionary: [],
  ..._sharedStateSearch,
};

const searchReducer = (state = initialState, action) => {
  switch (action.type) {
    case searchActionConstants.SEARCH_SUCCESS:
      return { ...state, ...action.data };
    case searchActionConstants.SEARCH_CLEAR:
      return {
        ...state,
        searchParams: { ...state.searchParams, [SEARCH_PARAM_QUERY_NAME]: "" },
        search: {
          total: 0,
          results: [],
          languageFacets: {},
        },
      };
    case searchActionConstants.RESET:
      return {
        ...state,
        searchParams: initialState.searchParams,
        search: initialState.search,
      };
    case searchActionConstants.ACTION_SEARCH_PARAMS_UPDATE:
      return { ...state, searchParams: { ...formatSearchParams(action.data) } };
    case searchActionConstants.ACTION_SEARCH_CURRENT_ITEM_UPDATE:
      return { ...state, currentItemIndex: action.data };
    case searchActionConstants.SEARCH_TOGGLE_MARKS:
      return { ...state, isShownMarks: !state.isShownMarks };
    case searchActionConstants.FETCH_SEARCH_DICTIONARY_SUCCESS: {
      return {
        ...state,
        searchParamsDictionary: action.data.params,
        searchDictionary: action.data.results,
      };
    }
    default:
      return _sharedReducerSearch(state, action);
  }
};
export default searchReducer;
